<template>
  <section class="pillars-section">
    <div class="container pillars-shell">
      <div class="pillars-header">
        <h2 class="pillars-title">Pilar PI-Utilitas</h2>
        <p class="pillars-subtitle">{{ $t('companyPillars.subtitle') }}</p>
      </div>

      <div class="pillars-layout">
        <aside class="pillars-nav" role="tablist" aria-label="PI Utilitas pillars">
          <button
            v-for="item in tabs"
            :key="item.id"
            type="button"
            class="pillar-tab"
            :class="{ active: activeTab === item.id }"
            :aria-selected="String(activeTab === item.id)"
            @click="activeTab = item.id"
          >
            <span class="pillar-tab-code">{{ item.code }}</span>
            <span class="pillar-tab-label">{{ item.label }}</span>
          </button>
        </aside>

        <section
          class="pillar-panel"
          :class="{ 'is-corporate-value': activeTab === 'corporate-value' }"
        >
          <div class="pillar-panel-header">
            <span class="pillar-panel-code">{{ currentTab.code }}</span>
            <h3 class="pillar-panel-title">{{ currentTab.label }}</h3>
          </div>

          <div v-if="activeTab === 'vision'" class="pillar-copy">
            <p>{{ $t('companyPillars.vision') }}</p>
          </div>

          <ul v-else-if="activeTab === 'mission'" class="mission-list">
            <li v-for="(item, index) in missionItems" :key="`mission-${index}`">
              {{ item }}
            </li>
          </ul>

          <div v-else-if="activeTab === 'business-line'" class="cards-grid">
            <article
              v-for="item in businessLineItems"
              :key="item.title"
              class="info-card"
              :class="{ wide: item.wide }"
            >
              <span class="info-card-chip">{{ item.short }}</span>
              <h4>{{ item.title }}</h4>
              <p v-if="item.subtitle">{{ item.subtitle }}</p>
            </article>
          </div>

          <div v-else-if="activeTab === 'business-enabler'" class="cards-grid compact-grid">
            <article
              v-for="item in businessEnablerItems"
              :key="item.title"
              class="info-card compact"
            >
              <span class="info-card-chip">{{ item.short }}</span>
              <h4>{{ item.title }}</h4>
            </article>
          </div>

          <div v-else class="corporate-value-panel">
            <div class="corporate-value-frame">
              <img class="img-fluid" src="../assets/akhlak_main.png" alt="Corporate Value" />
            </div>
          </div>
        </section>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'CompanyPillars',
  data() {
    return {
      activeTab: 'vision'
    };
  },
  computed: {
    localeTag() {
      return this.$i18n.locale;
    },
    tabs() {
      this.localeTag;

      return [
        {
          id: 'vision',
          code: '01',
          label: this.$t('companyPillars.visionTitle')
        },
        {
          id: 'mission',
          code: '02',
          label: this.$t('companyPillars.missionTitle')
        },
        {
          id: 'business-line',
          code: '03',
          label: 'Business Line'
        },
        {
          id: 'business-enabler',
          code: '04',
          label: 'Business Enabler'
        },
        {
          id: 'corporate-value',
          code: '05',
          label: 'Corporate Value'
        }
      ];
    },
    currentTab() {
      return this.tabs.find((item) => item.id === this.activeTab) || this.tabs[0];
    },
    missionItems() {
      this.localeTag;

      return [
        this.$t('companyPillars.mission.item1'),
        this.$t('companyPillars.mission.item2'),
        this.$t('companyPillars.mission.item3'),
        this.$t('companyPillars.mission.item4')
      ];
    },
    businessLineItems() {
      this.localeTag;

      return [
        {
          short: 'EL',
          title: this.$t('companyPillars.businessLine.title1')
        },
        {
          short: 'WA',
          title: this.$t('companyPillars.businessLine.title2')
        },
        {
          short: 'GS',
          title: this.$t('companyPillars.businessLine.title3')
        },
        {
          short: 'OM',
          title: this.$t('companyPillars.businessLine.title4')
        },
        {
          short: 'UX',
          title: this.$t('companyPillars.businessLine.title5'),
          subtitle: this.$t('companyPillars.businessLine.title5sub'),
          wide: true
        }
      ];
    },
    businessEnablerItems() {
      this.localeTag;

      return [
        {
          short: 'BD',
          title: this.$t('companyPillars.businessEnabler.card1')
        },
        {
          short: 'SC',
          title: this.$t('companyPillars.businessEnabler.card2')
        },
        {
          short: 'OE',
          title: this.$t('companyPillars.businessEnabler.card3')
        },
        {
          short: 'IT',
          title: this.$t('companyPillars.businessEnabler.card4')
        },
        {
          short: 'RM',
          title: 'Enterprise Risk Management'
        },
        {
          short: 'GC',
          title: 'GCG'
        },
        {
          short: 'AU',
          title: 'Audit'
        }
      ];
    }
  }
};
</script>

<style scoped>
.pillars-section {
  --pillar-navy: #0b4f8a;
  --pillar-blue: #1273a8;
  --pillar-teal: #1aa3b2;
  --pillar-ink: #16324a;
  --pillar-border: rgba(11, 79, 138, 0.14);
  --pillar-surface: rgba(255, 255, 255, 0.76);
  position: relative;
  overflow: hidden;
  isolation: isolate;
  background-image: url("../assets/Pattern_4.png");
  background-size: cover;
  background-position: center top;
  background-repeat: no-repeat;
}

.pillars-section::before {
  content: "";
  position: absolute;
  inset: 0;
  background:
    radial-gradient(circle at top left, rgba(133, 200, 255, 0.2), transparent 34%),
    radial-gradient(circle at top right, rgba(17, 160, 195, 0.14), transparent 30%),
    linear-gradient(to bottom, rgba(247, 250, 252, 0.95) 0%, #f7fafc 100%);
  z-index: -2;
}

.pillars-section::after {
  content: "";
  position: absolute;
  inset: auto auto 12% -8%;
  width: 280px;
  height: 280px;
  border-radius: 999px;
  background: radial-gradient(circle, rgba(17, 160, 195, 0.12) 0%, transparent 72%);
  filter: blur(10px);
  z-index: -1;
}

.pillars-shell {
  position: relative;
  z-index: 1;
  padding: clamp(64px, 8vw, 104px) 0 clamp(56px, 7vw, 88px);
}

.pillars-header {
  max-width: 1120px;
  margin-bottom: clamp(28px, 4vw, 40px);
}

.pillars-title {
  margin: 0;
  color: var(--pillar-navy);
  font-size: clamp(2.3rem, 4vw, 3.6rem);
  font-style: italic;
  font-weight: 800;
  line-height: 0.95;
  letter-spacing: -0.04em;
}

.pillars-subtitle {
  margin: 20px 0 0;
  max-width: 1100px;
  color: #263a4a;
  font-size: clamp(1rem, 1.35vw, 1.42rem);
  font-weight: 600;
  line-height: 1.65;
}

.pillars-layout {
  display: grid;
  grid-template-columns: minmax(220px, 290px) minmax(0, 1fr);
  gap: clamp(20px, 3vw, 32px);
  align-items: start;
}

.pillars-nav {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding-top: 8px;
}

.pillar-tab {
  width: 100%;
  border: 1px solid var(--pillar-border);
  border-radius: 24px;
  padding: 14px 16px;
  display: flex;
  align-items: center;
  gap: 14px;
  background: var(--pillar-surface);
  color: var(--pillar-ink);
  text-align: left;
  box-shadow: 0 20px 60px -42px rgba(11, 79, 138, 0.45);
  backdrop-filter: blur(14px);
  transition:
    transform 0.24s ease,
    box-shadow 0.24s ease,
    background 0.24s ease,
    border-color 0.24s ease,
    color 0.24s ease;
}

.pillar-tab:hover {
  transform: translateX(6px);
  border-color: rgba(18, 115, 168, 0.35);
  box-shadow: 0 28px 64px -38px rgba(11, 79, 138, 0.5);
}

.pillar-tab.active {
  transform: translateX(12px);
  color: white;
  border-color: transparent;
  background: linear-gradient(135deg, #0d5b97 0%, #1080ba 55%, #1aa7ae 100%);
  box-shadow: 0 30px 72px -34px rgba(7, 62, 105, 0.82);
}

.pillar-tab-code {
  flex: 0 0 48px;
  width: 48px;
  height: 48px;
  display: grid;
  place-items: center;
  border-radius: 16px;
  background: rgba(11, 79, 138, 0.08);
  color: var(--pillar-navy);
  font-size: 0.92rem;
  font-weight: 800;
  letter-spacing: 0.14em;
}

.pillar-tab.active .pillar-tab-code {
  background: rgba(255, 255, 255, 0.16);
  color: white;
}

.pillar-tab-label {
  display: block;
  min-width: 0;
  font-size: 1.02rem;
  font-weight: 700;
  line-height: 1.3;
}

.pillar-panel {
  position: relative;
  min-height: 560px;
  padding: clamp(28px, 4vw, 42px);
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 34px;
  background: linear-gradient(145deg, #0a4e89 0%, #0f6ea7 48%, #1192a8 100%);
  color: white;
  box-shadow: 0 42px 120px -54px rgba(7, 51, 92, 0.86);
}

.pillar-panel::before {
  content: "";
  position: absolute;
  inset: auto -10% 56% auto;
  width: 240px;
  height: 240px;
  border-radius: 999px;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.26) 0%, rgba(255, 255, 255, 0) 72%);
}

.pillar-panel::after {
  content: "";
  position: absolute;
  inset: 50% auto auto -8%;
  width: 220px;
  height: 220px;
  border-radius: 999px;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.16) 0%, rgba(255, 255, 255, 0) 72%);
}

.pillar-panel > * {
  position: relative;
  z-index: 1;
}

.pillar-panel.is-corporate-value {
  background: linear-gradient(145deg, #094878 0%, #0c5e8f 48%, #0b7d8f 100%);
}

.pillar-panel-header {
  display: flex;
  align-items: center;
  gap: 18px;
  margin-bottom: 26px;
  padding-bottom: 22px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
}

.pillar-panel-code {
  flex: 0 0 64px;
  width: 64px;
  height: 64px;
  display: grid;
  place-items: center;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.12);
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.08);
  font-size: 1rem;
  font-weight: 800;
  letter-spacing: 0.16em;
}

.pillar-panel-title {
  margin: 0;
  color: #ffffff;
  font-size: clamp(1.95rem, 3.2vw, 2.65rem);
  font-style: italic;
  font-weight: 800;
  line-height: 1.05;
  letter-spacing: -0.04em;
}

.pillar-copy p {
  margin: 0;
  max-width: 920px;
  color: rgba(255, 255, 255, 0.97);
  font-size: clamp(1.04rem, 1vw, 1.28rem);
  line-height: 1.8;
}

.mission-list {
  margin: 0;
  padding: 0;
  list-style: none;
  counter-reset: mission;
  display: grid;
  gap: 14px;
}

.mission-list li {
  counter-increment: mission;
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: start;
  gap: 16px;
  padding: 18px 20px;
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: 22px;
  background: rgba(255, 255, 255, 0.1);
  font-size: 1rem;
  line-height: 1.7;
}

.mission-list li::before {
  content: counter(mission, decimal-leading-zero);
  width: 44px;
  height: 44px;
  display: grid;
  place-items: center;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.14);
  font-size: 0.9rem;
  font-weight: 800;
  letter-spacing: 0.12em;
}

.cards-grid {
  display: grid;
  grid-template-columns: repeat(12, minmax(0, 1fr));
  gap: 16px;
}

.info-card {
  grid-column: span 6;
  min-height: 176px;
  padding: 22px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 26px;
  background: rgba(255, 255, 255, 0.11);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.06);
}

.info-card.wide {
  grid-column: 1 / -1;
  min-height: 160px;
}

.info-card.compact {
  grid-column: span 4;
  min-height: 156px;
}

.info-card-chip {
  align-self: flex-start;
  padding: 8px 12px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.12);
  font-size: 0.78rem;
  font-weight: 800;
  letter-spacing: 0.16em;
  text-transform: uppercase;
}

.info-card h4 {
  margin: 0;
  color: #ffffff;
  font-size: clamp(1.04rem, 1.2vw, 1.28rem);
  font-weight: 700;
  line-height: 1.45;
}

.info-card p {
  margin: 0;
  max-width: 740px;
  color: rgba(255, 255, 255, 0.84);
  font-size: 0.96rem;
  line-height: 1.7;
}

.corporate-value-panel {
  display: flex;
}

.corporate-value-frame {
  width: 100%;
  padding: clamp(18px, 3vw, 26px);
  border-radius: 28px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.98) 0%, rgba(238, 246, 250, 0.94) 100%);
  box-shadow:
    inset 0 0 0 1px rgba(255, 255, 255, 0.65),
    0 24px 60px -45px rgba(5, 40, 72, 0.5);
}

.corporate-value-frame img {
  width: 100%;
  display: block;
  border-radius: 20px;
}

@media (max-width: 991px) {
  .pillars-layout {
    grid-template-columns: 1fr;
  }

  .pillars-nav {
    flex-direction: row;
    overflow-x: auto;
    padding: 0 4px 8px;
    margin: 0 -4px;
  }

  .pillar-tab {
    min-width: 220px;
  }

  .pillar-tab,
  .pillar-tab:hover,
  .pillar-tab.active {
    transform: none;
  }

  .pillar-panel {
    min-height: auto;
  }

  .info-card.compact {
    grid-column: span 6;
  }
}

@media (max-width: 767px) {
  .pillars-shell {
    padding-top: 52px;
  }

  .pillars-title {
    font-size: clamp(2.2rem, 12vw, 3.2rem);
  }

  .pillars-subtitle {
    font-size: 1rem;
  }

  .pillar-panel {
    padding: 22px 18px;
    border-radius: 26px;
  }

  .pillar-panel-header {
    align-items: flex-start;
  }

  .pillar-panel-code {
    flex-basis: 56px;
    width: 56px;
    height: 56px;
    border-radius: 18px;
  }

  .pillar-panel-title {
    font-size: 2rem;
  }

  .cards-grid {
    grid-template-columns: 1fr;
  }

  .info-card,
  .info-card.compact,
  .info-card.wide {
    grid-column: auto;
    min-height: unset;
  }

  .mission-list li {
    grid-template-columns: 1fr;
  }

  .mission-list li::before {
    margin-bottom: 6px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .pillar-tab {
    transition: none;
  }
}
</style>
